'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChartLine = function TiChartLine(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm7.9 25.9c0.6 0.5 1.4 0.8 2.1 0.8 1 0 1.9-0.5 2.6-1.3l4.7-5.8 4 3.1c1.5 1 3.5 0.8 4.6-0.6l6.7-8.4c1.2-1.4 0.9-3.5-0.5-4.6-1.5-1.2-3.6-1-4.7 0.5l-4.7 5.8-4-3.1c-1.5-1-3.5-0.8-4.6 0.6l-6.7 8.4c-1.2 1.4-0.9 3.5 0.5 4.6z m0.4 9.1h23.4c0.9 0 1.6-0.7 1.6-1.7s-0.7-1.6-1.6-1.6h-23.4c-0.9 0-1.6 0.7-1.6 1.6s0.7 1.7 1.6 1.7z' })
        )
    );
};

exports.default = TiChartLine;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chart-line.js
// module id = 3578
// module chunks = 0